const EnviromentData = [
    {
        id : "1",
        schemeName: "Paryavaran Vahini Scheme by Ministry of Environment and Forests",
        discription:"Paryavaran Vahini scheme was launched by the ministry during 1992-93 to create environmental awareness and to encourage involvement of people through active participation as well as to report illegal acts pertaining to forests, wildlife, pollution and environmental degradation.",
        launchDate: "01-Nov-2021 ",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Department-wise schemes of Ministry of Rural Development",
    discription:"Different ministries of the government of India formulate various development schemes not to raise the profit but to maximise the welfare of the people. Some schemes like National Rural Livelihood Mission, MGNREGA, Bharat Nirman etc. are made by the government for rural development of India.    ",
    launchDate: "20 January 1980;",
    AnualFund: "12345"},
   

    {id : "3",
    schemeName: "Information Education and Communication Scheme",
    discription:"While the words information, education, and communication have individual meanings, when grouped together as IEC, they are familiar to many within the field of health communication. However, the definition and scope of IEC can vary. In an effort to explore how IEC can be integrated into social change efforts, this issue of the Drum Beat presents just a few examples of what types of IEC strategies and resources are being used in diverse health contexts, worldwide",
    launchDate: "May 19, 2008",
    AnualFund: "12345"},
   
    {
    id : "4",
        schemeName: "Skill India",
        discription:"This skill development mission was launched on the 15th of July 2015 to train about 40 Crore Indians so that they contribute better to the economy. The initiatives under this scheme are –Skill loan scheme, Pradhan Mantri Kaushal Vikas Yojana, National Policy for Skill Development and Entrepreneurship, National Skill Development Mission.",
        launchDate: "15 July 2015",
        AnualFund: "12345"
    },
   { id : "5",
    schemeName: "Mudra Yojana",
    discription:"Pradhan Mantri MUDRA Yojana (PMMY) was launched on 8th April 2015, where MUDRA stands for Micro Units Development and Refinance Agency. ",
    launchDate: "8 Aprile 2015", 
     AnualFund: "12345"},
   

 


]
export default EnviromentData